/**
 * Refund Policy Page
 * 
 * Public page (no authentication required)
 * Refund policy for subscriptions and payments
 */

import React from "react";
import { PublicLayout } from "../components/public/PublicLayout";
import "./LegalPages.css";

export function RefundPolicyPage(): JSX.Element {
  return (
    <PublicLayout>
      <div className="legal-page">
      <div className="legal-page__container">
        <h1>Refund Policy</h1>
        <p className="legal-page__last-updated">Last Updated: January 4, 2026</p>
        
        <section className="legal-page__section">
          <h2>1. Subscription Refunds</h2>
          <p>
            <strong>All subscription payments are final.</strong> We do not offer refunds for subscription fees once payment has been verified and the subscription has been activated.
          </p>
        </section>

        <section className="legal-page__section">
          <h2>2. Payment Verification</h2>
          <p>
            Payments are verified through blockchain confirmation. Once a payment is verified and your subscription is activated, 
            the payment is considered final and non-refundable.
          </p>
        </section>

        <section className="legal-page__section">
          <h2>3. Payment Errors</h2>
          <p>
            If you believe there was an error in your payment:
          </p>
          <ul>
            <li>Contact support immediately with your Payment Intent ID</li>
            <li>Provide the transaction hash (tx_hash) from your payment</li>
            <li>We will investigate and resolve legitimate errors</li>
          </ul>
        </section>

        <section className="legal-page__section">
          <h2>4. Service Interruptions</h2>
          <p>
            If the Service experiences extended downtime or technical issues that prevent you from using the Service:
          </p>
          <ul>
            <li>Contact support to report the issue</li>
            <li>We may provide service credits or extensions at our discretion</li>
            <li>Refunds are not guaranteed for service interruptions</li>
          </ul>
        </section>

        <section className="legal-page__section">
          <h2>5. Cancellation</h2>
          <p>
            You may cancel your subscription at any time. Cancellation will take effect at the end of your current billing period. 
            You will continue to have access to the Service until the end of your paid period.
          </p>
        </section>

        <section className="legal-page__section">
          <h2>6. Chargebacks</h2>
          <p>
            <strong>Chargebacks are not permitted.</strong> If you initiate a chargeback, your account will be immediately suspended 
            and you may be banned from using the Service. Please contact support to resolve payment issues instead.
          </p>
        </section>

        <section className="legal-page__section">
          <h2>7. Contact for Refund Requests</h2>
          <p>
            If you believe you are entitled to a refund under exceptional circumstances, please contact support with:
          </p>
          <ul>
            <li>Your account email</li>
            <li>Payment Intent ID</li>
            <li>Transaction hash</li>
            <li>Detailed explanation of why you believe a refund is warranted</li>
          </ul>
          <p>
            All refund requests are reviewed on a case-by-case basis. We reserve the right to deny refund requests that do not 
            meet our refund policy criteria.
          </p>
        </section>

        <section className="legal-page__section">
          <h2>8. Changes to This Policy</h2>
          <p>
            We reserve the right to modify this Refund Policy at any time. Changes will be effective immediately upon posting 
            on this page.
          </p>
        </section>
      </div>
      </div>
    </PublicLayout>
  );
}

export default RefundPolicyPage;

